// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1MRGS","inner":"Footer_inner__3MK68","nextIcon":"Footer_nextIcon__2e8sW","innerLeft":"Footer_innerLeft__12ZDE"};